module.exports = "/images/extreme-cold@3x.png?5c98fad9b744b83cb0d4c9a1eff35937";